export default {
    DEFAULT: "DEFAULT",
    ONLINE: 'ONLINE',
    HELPSUPPORT: 'HELPSUPPORT',
    URL_FORM_ENCODED: 'URL_FORM_ENCODED',
    CHATBOT: 'CHATBOT',
    MAP_MY_INDIA: 'MAP_MY_INDIA'
}